/**
 * Gate 3D — dataLayer + UTM 90d + modais
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'g3d_utm_v1';
  var DAYS = 90;

  function now() {
    return Date.now();
  }

  function uuid() {
    return 'g3d_' + now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  function readParams() {
    var out = {};
    try {
      var q = window.location.search.replace(/^\?/, '').split('&');
      for (var i = 0; i < q.length; i++) {
        if (!q[i]) continue;
        var parts = q[i].split('=');
        var k = decodeURIComponent(parts[0] || '');
        var v = decodeURIComponent((parts[1] || '').replace(/\+/g, ' '));
        if (k) out[k] = v;
      }
    } catch (e) {}
    return out;
  }

  function loadUtm() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.expires || data.expires < now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data.values || null;
    } catch (e) {
      return null;
    }
  }

  function saveUtm(values) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ expires: now() + DAYS * 24 * 60 * 60 * 1000, values: values })
      );
      document.cookie =
        STORAGE_KEY +
        '=' +
        encodeURIComponent(JSON.stringify(values)) +
        ';path=/;max-age=' +
        String(DAYS * 24 * 60 * 60) +
        ';SameSite=Lax';
    } catch (e) {}
  }

  function captureUtm() {
    var params = readParams();
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
    var found = false;
    var values = loadUtm() || {};
    for (var i = 0; i < keys.length; i++) {
      if (params[keys[i]]) {
        values[keys[i]] = params[keys[i]];
        found = true;
      }
    }
    if (found) saveUtm(values);
    return loadUtm() || values || {};
  }

  function fillUtmFields() {
    var utm = loadUtm() || {};
    var fields = document.querySelectorAll('[data-g3d-utm]');
    for (var i = 0; i < fields.length; i++) {
      var key = fields[i].getAttribute('data-g3d-utm');
      if (key && utm[key]) fields[i].value = utm[key];
    }
  }

  function basePayload(eventName, extra) {
    var utm = loadUtm() || {};
    var payload = {
      event: eventName,
      event_id: uuid(),
      page_url: window.location.href,
      referrer: document.referrer || '',
      product_id: '',
      product_name: '',
      product_family: '',
      product_category: '',
      value: '',
      currency: 'BRL',
      utm_source: utm.utm_source || '',
      utm_medium: utm.utm_medium || '',
      utm_campaign: utm.utm_campaign || '',
      utm_content: utm.utm_content || '',
      utm_term: utm.utm_term || '',
      gclid: utm.gclid || '',
      fbclid: utm.fbclid || ''
    };
    if (extra) {
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k) && extra[k] != null && extra[k] !== '') {
          payload[k] = extra[k];
        }
      }
    }
    return payload;
  }

  function push(eventName, extra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(basePayload(eventName, extra));
  }

  function openModal(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.hidden = false;
    el.setAttribute('data-open', '1');
    document.documentElement.style.overflow = 'hidden';
    fillUtmFields();
    var focusable = el.querySelector('input, select, textarea, button');
    if (focusable) {
      try {
        focusable.focus();
      } catch (e) {}
    }
  }

  function closeModals() {
    var modals = document.querySelectorAll('[data-g3d-modal]');
    for (var i = 0; i < modals.length; i++) {
      modals[i].hidden = true;
      modals[i].removeAttribute('data-open');
    }
    document.documentElement.style.overflow = '';
  }

  function waUrl(message) {
    return 'https://api.whatsapp.com/send?phone=5551999579713&text=' + encodeURIComponent(message);
  }

  function bindClicks() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var openQuote = t.closest('[data-g3d-open-quote]');
      if (openQuote) {
        e.preventDefault();
        push(
          openQuote.getAttribute('data-g3d-track') || 'quote_request',
          {
            product_family: openQuote.getAttribute('data-product-family') || 'orcamento',
            banner_name: openQuote.getAttribute('data-banner-name') || '',
            cta_label: openQuote.getAttribute('data-cta-label') || (openQuote.textContent || '').trim()
          }
        );
        openModal('g3d-quote-modal');
        return;
      }

      var openCatalog = t.closest('[data-g3d-open-catalog]');
      if (openCatalog) {
        e.preventDefault();
        push(
          openCatalog.getAttribute('data-g3d-track') || 'catalog_download',
          {
            product_family: openCatalog.getAttribute('data-product-family') || 'maquina',
            banner_name: openCatalog.getAttribute('data-banner-name') || '',
            cta_label: openCatalog.getAttribute('data-cta-label') || (openCatalog.textContent || '').trim()
          }
        );
        openModal('g3d-catalog-modal');
        return;
      }

      if (t.closest('[data-g3d-close-modal]')) {
        e.preventDefault();
        closeModals();
        return;
      }

      if (t.closest('[data-g3d-open-quote], [data-g3d-open-catalog]')) return;
      if (t.closest('form[data-g3d-quote-form] button, form[data-g3d-catalog-form] button')) return;

      var trackEl = t.closest('[data-g3d-track]');
      if (trackEl) {
        var ev = trackEl.getAttribute('data-g3d-track');
        if (!ev) return;
        push(ev, {
          product_id: trackEl.getAttribute('data-product-id') || '',
          product_name: trackEl.getAttribute('data-product-name') || '',
          product_family:
            trackEl.getAttribute('data-product-family') || trackEl.getAttribute('data-g3d-wa') || '',
          product_category: trackEl.getAttribute('data-product-category') || '',
          value: trackEl.getAttribute('data-product-value') || '',
          banner_name: trackEl.getAttribute('data-banner-name') || '',
          cta_label: trackEl.getAttribute('data-cta-label') || (trackEl.textContent || '').trim()
        });
      }
    });
  }

  function bindEsc() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeModals();
    });
  }

  function bindForms() {
    var quoteForm = document.querySelector('[data-g3d-quote-form]');
    if (quoteForm) {
      quoteForm.addEventListener('submit', function (e) {
        e.preventDefault();
        fillUtmFields();
        var fd = new FormData(quoteForm);
        var interest = fd.get('interest') || 'orcamento';
        var text =
          'Olá, gostaria de solicitar orçamento técnico de impressão 3D.\n' +
          'Nome: ' + (fd.get('name') || '') + '\n' +
          'Empresa: ' + (fd.get('company') || '') + '\n' +
          'WhatsApp: ' + (fd.get('whatsapp') || '') + '\n' +
          'E-mail: ' + (fd.get('email') || '') + '\n' +
          'Interesse: ' + interest + '\n' +
          'Quantidade: ' + (fd.get('quantity') || '-') + '\n' +
          'Prazo: ' + (fd.get('deadline') || '-') + '\n' +
          'Observação: ' + (fd.get('message') || '-') + '\n' +
          'UTM: ' + (fd.get('utm_source') || '') + '/' + (fd.get('utm_campaign') || '');
        push('form_submit', { product_family: interest, form: 'quote' });
        push('quote_request', { product_family: interest });
        window.open(waUrl(text), '_blank', 'noopener');
        closeModals();
      });
    }

    var catalogForm = document.querySelector('[data-g3d-catalog-form]');
    if (catalogForm) {
      catalogForm.addEventListener('submit', function (e) {
        e.preventDefault();
        fillUtmFields();
        var fd = new FormData(catalogForm);
        var interest = fd.get('interest') || 'completo';
        var text =
          'Olá, quero receber o catálogo de equipamentos Gate 3D.\n' +
          'Nome: ' + (fd.get('name') || '') + '\n' +
          'Empresa: ' + (fd.get('company') || '') + '\n' +
          'WhatsApp: ' + (fd.get('whatsapp') || '') + '\n' +
          'E-mail: ' + (fd.get('email') || '') + '\n' +
          'Interesse: ' + interest;
        push('form_submit', { product_family: 'maquina', form: 'catalog', product_category: interest });
        push('catalog_download', { product_family: 'maquina', product_category: interest });
        window.open(waUrl(text), '_blank', 'noopener');
        closeModals();
      });
    }

    var selector = document.querySelector('[data-g3d-selector]');
    if (selector) {
      selector.addEventListener('submit', function (e) {
        e.preventDefault();
        var checked = selector.querySelector('input[name="g3d_need"]:checked');
        var need = checked ? checked.value : 'resina';
        push('material_selector_submit', { product_family: need });
        if (need === 'resina') window.location.href = '/collections/all';
        else if (need === 'filamento') window.location.href = '/collections/filamentos';
        else if (need === 'maquina') {
          push('machine_interest', { product_family: 'maquina' });
          window.location.href = '/pages/equipamentos';
        } else openModal('g3d-quote-modal');
      });
    }

    bindSelectorCards();
  }

  function bindSelectorCards() {
    var wrap = document.querySelector('[data-g3d-selector-cards]');
    if (!wrap) return;
    var map = {
      resina: {
        title: 'Catálogo de resinas técnicas',
        text: 'Comece pelas resinas Gate 3D — linha ativa para engenharia, flexíveis, dental e alta temperatura.',
        cta: 'Comparar soluções · Comprar resinas',
        href: '/collections/all'
      },
      filamento: {
        title: 'Filamentos em curadoria',
        text: 'Linha FDM em preparação. Fale com um especialista para indicação técnica ou aviso de disponibilidade.',
        cta: 'Falar com especialista',
        href: '/collections/filamentos'
      },
      maquina: {
        title: 'Máquinas e equipamentos',
        text: 'Solução consultiva B2B: compra, locação, cura UV, treinamento e suporte nacional.',
        cta: 'Ver equipamentos',
        href: '/pages/equipamentos'
      },
      orcamento: {
        title: 'Impressão 3D sob medida',
        text: 'Envie o arquivo ou descreva a aplicação — retornamos com análise técnica e prazo.',
        cta: 'Solicitar orçamento técnico',
        href: '#quote'
      }
    };
    var titleEl = document.querySelector('[data-g3d-reco-title]');
    var textEl = document.querySelector('[data-g3d-reco-text]');
    var ctaEl = document.querySelector('[data-g3d-reco-cta]');

    function apply(need) {
      var item = map[need] || map.resina;
      if (titleEl) titleEl.textContent = item.title;
      if (textEl) textEl.textContent = item.text;
      if (ctaEl) {
        ctaEl.textContent = item.cta;
        ctaEl.setAttribute('href', item.href === '#quote' ? '#' : item.href);
        ctaEl.setAttribute('data-product-family', need);
        if (item.href === '#quote') {
          ctaEl.setAttribute('data-g3d-open-quote', '1');
          ctaEl.removeAttribute('data-g3d-track');
        } else {
          ctaEl.removeAttribute('data-g3d-open-quote');
          ctaEl.setAttribute('data-g3d-track', 'material_selector_submit');
        }
      }
    }

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-g3d-need]');
      if (!btn) return;
      var need = btn.getAttribute('data-g3d-need') || 'resina';
      var cards = wrap.querySelectorAll('[data-g3d-need]');
      for (var i = 0; i < cards.length; i++) {
        var on = cards[i] === btn;
        cards[i].classList.toggle('is-active', on);
        cards[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      apply(need);
      push('material_selector_submit', { product_family: need });
    });

    if (ctaEl) {
      ctaEl.addEventListener('click', function (e) {
        if (ctaEl.hasAttribute('data-g3d-open-quote')) {
          e.preventDefault();
          push('quote_request', { product_family: 'orcamento' });
          openModal('g3d-quote-modal');
        }
      });
    }
  }

  function bindTagFilters() {
    var wrap = document.querySelector('[data-g3d-tag-filters]');
    if (!wrap) return;
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-g3d-tag]');
      if (!btn) return;
      var tag = (btn.getAttribute('data-g3d-tag') || '').toLowerCase();
      var chips = wrap.querySelectorAll('[data-g3d-tag]');
      for (var i = 0; i < chips.length; i++) chips[i].classList.toggle('is-active', chips[i] === btn);
      var cards = document.querySelectorAll('#product-grid .g3d-card, .product-grid .g3d-card');
      for (var j = 0; j < cards.length; j++) {
        var card = cards[j];
        var li = card.closest('.grid__item') || card;
        if (!tag) {
          li.style.display = '';
          continue;
        }
        var tags = (card.getAttribute('data-g3d-tags') || '').toLowerCase();
        var title = (card.textContent || '').toLowerCase();
        var show =
          tags.indexOf(tag) !== -1 ||
          (tag === 'tecnica' && (title.indexOf('abs') !== -1 || title.indexOf('pc like') !== -1 || title.indexOf('nylon') !== -1 || title.indexOf('cera') !== -1 || tags.indexOf('engenharia') !== -1)) ||
          (tag === 'flexivel' && (title.indexOf('rubber') !== -1 || title.indexOf('tpu') !== -1 || title.indexOf('pu like') !== -1 || title.indexOf('silicone') !== -1)) ||
          (tag === 'transparente' && (title.indexOf('clear') !== -1 || title.indexOf('cristal') !== -1 || title.indexOf('glass') !== -1)) ||
          (tag === 'alta-temperatura' && title.indexOf('temperatura') !== -1) ||
          (tag === 'lavavel' && title.indexOf('lav') !== -1) ||
          (tag === 'geral' && (title.indexOf('general') !== -1 || title.indexOf('standard') !== -1 || title.indexOf('cinza') !== -1)) ||
          (tag === 'dental' && title.indexOf('dental') !== -1);
        li.style.display = show ? '' : 'none';
      }
    });
  }

  function trackViewItem() {
    var tech = document.querySelector('.g3d-tech');
    var isProduct =
      document.body.classList.contains('template-product') ||
      window.location.pathname.indexOf('/products/') !== -1;
    if (!tech && !isProduct) return;
    push('view_item', {
      product_id: (tech && tech.getAttribute('data-g3d-product-id')) || '',
      product_name: (tech && tech.getAttribute('data-g3d-product-name')) || document.title,
      product_family: (tech && tech.getAttribute('data-g3d-family')) || 'resina',
      value: (tech && tech.getAttribute('data-g3d-product-price')) || ''
    });
  }

  function pushAddToCart(form) {
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var tech = document.querySelector('.g3d-tech');
    push('add_to_cart', {
      product_id: idInput ? idInput.value : '',
      product_name: tech ? tech.getAttribute('data-g3d-product-name') : document.title,
      product_family: tech ? tech.getAttribute('data-g3d-family') : 'resina',
      value: tech ? tech.getAttribute('data-g3d-product-price') : '',
      currency: 'BRL'
    });
  }

  function bindCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = (form.getAttribute('action') || '').toLowerCase();
      if (action.indexOf('/cart/add') !== -1 || (form.getAttribute('id') || '').indexOf('product-form') !== -1) {
        pushAddToCart(form);
      }
    });

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var addBtn = t.closest('button[name="add"], .product-form__submit, button.product-form__submit');
      if (addBtn) {
        var form = addBtn.closest('form');
        pushAddToCart(form);
        return;
      }
      var checkoutBtn = t.closest(
        'button[name="checkout"], .cart__checkout-button, [name="checkout"], a[href*="/checkout"]'
      );
      if (checkoutBtn) {
        push('begin_checkout', { currency: 'BRL' });
      }
    });

    if (window.location.pathname.indexOf('/checkouts') !== -1 || window.location.pathname.indexOf('/checkout') !== -1) {
      push('begin_checkout', { currency: 'BRL' });
    }
  }

  function enhanceFloatingWa() {
    var links = document.querySelectorAll('a[href*="whatsapp"], a[href*="leadstaker"], a[href*="api.whatsapp.com"]');
    for (var i = 0; i < links.length; i++) {
      if (!links[i].getAttribute('data-g3d-track')) {
        links[i].setAttribute('data-g3d-track', 'whatsapp_click');
      }
    }
  }

  function init() {
    captureUtm();
    fillUtmFields();
    bindClicks();
    bindEsc();
    bindForms();
    bindTagFilters();
    bindCart();
    enhanceFloatingWa();
    trackViewItem();
    window.Gate3DTracking = { push: push, captureUtm: captureUtm, openQuote: function () { openModal('g3d-quote-modal'); }, openCatalog: function () { openModal('g3d-catalog-modal'); }, closeModals: closeModals };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
